import { isOrderScriptSent } from "@nexus/contracts";

import type {
  SentScriptMeta,
  SentScriptPartnerSend,
  SentScriptsMap,
} from "../types/marketplace.types";

/** Every partner order for an item, newest first. */
export function partnerSendsOf(
  meta: SentScriptMeta | null | undefined,
): SentScriptPartnerSend[] {
  if (!meta) return [];
  return meta.partnerSends ?? [meta];
}

/** True when any partner order for this item has been handed off, not only the newest one. */
export function isSentToAnyPartner(meta: SentScriptMeta | null | undefined): boolean {
  return partnerSendsOf(meta).some((send) => isOrderScriptSent(send));
}

export function isScriptSentInMap(map: SentScriptsMap, scriptId: string): boolean {
  return isSentToAnyPartner(map[scriptId]);
}

/** The order this vendor already holds for the item, in any handoff state. */
export function findVendorSend(
  map: SentScriptsMap,
  itemId: string,
  vendorId: string,
): SentScriptPartnerSend | null {
  return partnerSendsOf(map[itemId]).find((send) => send.vendorId === vendorId) ?? null;
}

/** Items this vendor does not have an order for yet. One send per item per partner. */
export function itemIdsNotWithVendor(
  map: SentScriptsMap,
  itemIds: readonly string[],
  vendorId: string,
): string[] {
  return itemIds.filter((id) => findVendorSend(map, id, vendorId) === null);
}
